import { useState } from 'react';
import type { Moment } from 'moment';

import { generateUTCDateMoment } from '../services/utils';

const useDateRange = () => {
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');

    const handleDateChange = (dates: [Moment, Moment] | null) => {
        if (dates && dates[0] && dates[1]) {
            const startDate = generateUTCDateMoment(dates[0]).toISOString();
            const endDate = generateUTCDateMoment(dates[1]).toISOString();
            setStartTime(startDate);
            setEndTime(endDate);
        } else {
            setStartTime('');
            setEndTime('');
        }
    };

    return { startTime, endTime, handleDateChange };
};

export default useDateRange;
